<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.products')} / ${$t('menu.cars')}`"
      >
        <Cars></Cars>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// eslint-disable-next-line import/no-unresolved
import Cars from './tablas/Cars.vue'

export default {
  components: {
    AppCardCode,
    Cars,
  },
}
</script>
